import {SHOW_UPDATE_RECURRING_MODAL, SET_RECURRING_ORDER_DATA, SET_RECURRING_ITEM} from "../../actions/actionTypes";

export function storeRecurringOrderReducer(state, action) {
    state = state || {};
    switch (action.type) {
        case SET_RECURRING_ORDER_DATA:
            return Object.assign({}, action.data);
        case SHOW_UPDATE_RECURRING_MODAL:
            return Object.assign({}, state, {showUpdateRecurringModal: action.showUpdateRecurringModal});
        case SET_RECURRING_ITEM: {
            let items =  Object.assign([], state.items, []);
            let itemIndex = -1;
            (items||[]).find(function (item, index) {
                if(item && item.key === action.item.key) {
                    itemIndex = index;
                }
            });
            const newItem = action.item;
            if(itemIndex === -1 && newItem.quantity > 0) {
                items.push(action.item);
            } else {
                if(newItem.quantity === 0) {
                    items.splice(itemIndex, 1);
                } else {
                    if(!action.updateSchedule) {
                        newItem.schedule = items[itemIndex].schedule;
                    }
                    items[itemIndex] = newItem;
                }
            }
            return Object.assign({}, state, {items});
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/store/storeRecurringOrderReducer.js